export default __webpack_public_path__ + "static/web-programacion-c13ae191ac1cd92a13bd46454a3c7637.jpg";